module.exports = __webpack_public_path__ + "img/latency.7a6a0ab9.jpg";